import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';
import { FOOTBALLER_COLORS as C } from '../../../src/quiz/constants/footballerQuiz.constants';

export const footballerQuizResultOverlayStyles = StyleSheet.create({
  backdrop: { flex: 1, backgroundColor: 'rgba(0,0,0,0.82)', justifyContent: 'flex-end' },
  sheet: {
    backgroundColor: C.modal, borderTopLeftRadius: 24, borderTopRightRadius: 24,
    paddingHorizontal: 20, paddingTop: 12, paddingBottom: 36, borderTopWidth: 1, borderTopColor: 'rgba(167,139,250,0.2)',
  },
  handle: { width: 36, height: 4, borderRadius: 2, backgroundColor: C.inputBorder, alignSelf: 'center', marginBottom: 16 },

  // Heading
  heading: { alignItems: 'center', marginBottom: 16 },
  headingEmoji: { fontSize: 30, marginBottom: 6 },
  headingTitle: { fontSize: 20, fontWeight: '800', color: WARMUP_COLORS.text, letterSpacing: -0.2 },
  headingSub: { fontSize: 13, color: WARMUP_COLORS.textDim, marginTop: 4 },

  // Reveal card
  revealCard: {
    backgroundColor: C.surface, borderRadius: 16, paddingVertical: 14, paddingHorizontal: 16, marginBottom: 14,
    flexDirection: 'row', alignItems: 'center', gap: 12, borderWidth: 1, borderColor: 'rgba(167,139,250,0.15)',
  },
  revealAvatar: { width: 52, height: 52, borderRadius: 9999, backgroundColor: WARMUP_COLORS.purpleDeep, alignItems: 'center', justifyContent: 'center' },
  revealInitials: { fontSize: 18, fontWeight: '800', color: WARMUP_COLORS.text },
  revealBody: { flex: 1, minWidth: 0 },
  revealName: { fontSize: 17, fontWeight: '800', color: WARMUP_COLORS.text },
  revealMetaRow: { flexDirection: 'row', alignItems: 'center', gap: 5, marginTop: 3, flexWrap: 'wrap' },
  revealNat: { fontSize: 11, color: WARMUP_COLORS.textDim },
  revealDot: { fontSize: 11, color: C.inputBorder },
  revealClub: { fontSize: 11, fontWeight: '600', color: C.purple },
  revealPos: { fontSize: 10, fontWeight: '600', color: C.hintText, backgroundColor: C.chip, paddingVertical: 2, paddingHorizontal: 6, borderRadius: 5, overflow: 'hidden' },
  revealStatsRow: { flexDirection: 'row', gap: 10, marginTop: 5 },
  revealStat: { fontSize: 11, color: C.labelDim },
  revealStatStrong: { color: C.hintText, fontWeight: '700' },

  // Share grid
  shareBox: { backgroundColor: C.bg, borderRadius: 12, paddingVertical: 12, paddingHorizontal: 14, marginBottom: 14 },
  shareLabel: { fontSize: 9, fontWeight: '700', color: C.labelFaint, letterSpacing: 0.8, marginBottom: 8 },
  shareLine: { fontSize: 16, letterSpacing: 3, lineHeight: 26 },

  // Stats
  statsRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 20, marginBottom: 16 },
  stat: { alignItems: 'center' },
  statNumStreak: { fontSize: 26, fontWeight: '800', color: C.yellow, fontVariant: ['tabular-nums'] },
  statNumGuesses: { fontSize: 26, fontWeight: '800', color: C.purple, fontVariant: ['tabular-nums'] },
  statLabel: { fontSize: 10, fontWeight: '600', color: C.labelFaint, letterSpacing: 0.5, marginTop: 2, textTransform: 'uppercase' },
  statDivider: { width: 1, height: 36, backgroundColor: C.surface },

  // Coins
  coinsPill: { alignSelf: 'center', backgroundColor: 'rgba(252,211,77,0.12)', borderRadius: 9999, paddingVertical: 5, paddingHorizontal: 14, marginBottom: 14 },
  coinsText: { fontSize: 13, fontWeight: '700', color: C.yellow },

  // Buttons
  primaryButton: { height: 48, borderRadius: 10, backgroundColor: C.purple, alignItems: 'center', justifyContent: 'center', marginBottom: 10 },
  primaryText: { fontSize: 15, fontWeight: '700', color: C.modal },
  secondaryRow: { flexDirection: 'row', gap: 10 },
  secondaryButton: { flex: 1, height: 44, borderRadius: 10, borderWidth: 1, borderColor: C.inputBorder, alignItems: 'center', justifyContent: 'center' },
  secondaryText: { fontSize: 13, fontWeight: '600', color: C.hintText },
  secondaryTextDim: { color: C.labelDim },
  pressed: { opacity: 0.85 },
});
